import { useQuery } from 'react-query';

import { ContestResultProps } from '~/atomic/page/contest/ContestResult/ContestResult';
import { booksGraphql } from '~/graphql/books/booksGraphql';
import { GraphqlBook } from '~/graphql/books/factory/book/BookFactoryTypes';

export const useGetWinnerContestBook = (props: ContestResultProps) => {
  const initialData = {} as {
    winners: Array<GraphqlBook>,
    secondPlace: Array<GraphqlBook>,
    thirdPlace: Array<GraphqlBook>,
    shortList: Array<GraphqlBook>,
  };

  const result = useQuery(
    ['contestWinnerBook'],
    async () => {
      try {
        const [
          winnersResults,
          secondPlaceResults,
          thirdPlaceResults,
          shortListResults,
        ] = await Promise.all([
          Promise.all(
            props.winnerBookSlugs.map((bookSlug) => {
              return booksGraphql.getBookBySlug({ slug: bookSlug });
            }),
          ),
          Promise.all(
            props.secondPlace.map((bookSlug) => {
              return booksGraphql.getBookBySlug({ slug: bookSlug });
            }),
          ),
          Promise.all(
            props.thirdPlace.map((bookSlug) => {
              return booksGraphql.getBookBySlug({ slug: bookSlug });
            }),
          ),
          Promise.all(
            props.shortList.map((bookSlug) => {
              return booksGraphql.getBookBySlug({ slug: bookSlug });
            }),
          ),
        ]);

        return {
          winners: winnersResults,
          secondPlace: secondPlaceResults,
          thirdPlace: thirdPlaceResults,
          shortList: shortListResults,
        };
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    { placeholderData: initialData },
  );

  return { ...result, isLoading: result.isPlaceholderData };
};
